export function MenuFuelIcon() {
  return (
    <svg
      width='36'
      height='36'
      viewBox='0 0 36 36'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect width='36' height='36' rx='18' fill='#021542' />
      <path
        d='M21.5 16.5H22.5C23.0304 16.5 23.5391 16.7107 23.9142 17.0858C24.2893 17.4609 24.5 17.9696 24.5 18.5V21.5C24.5 21.8978 24.658 22.2794 24.9393 22.5607C25.2206 22.842 25.6022 23 26 23C26.3978 23 26.7794 22.842 27.0607 22.5607C27.342 22.2794 27.5 21.8978 27.5 21.5V14L24.5 11'
        stroke='#E4ECFF'
        strokeWidth='1.2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M11.5 25V11C11.5 10.4696 11.7107 9.96086 12.0858 9.58579C12.4609 9.21071 12.9696 9 13.5 9H19.5C20.0304 9 20.5391 9.21071 20.9142 9.58579C21.2893 9.96086 21.5 10.4696 21.5 11V25'
        stroke='#E4ECFF'
        strokeWidth='1.2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10.5 25H22.5'
        stroke='#E4ECFF'
        strokeWidth='1.2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M25.5 12V13C25.5 13.2652 25.6054 13.5196 25.7929 13.7071C25.9804 13.8946 26.2348 14 26.5 14H27.5'
        stroke='#E4ECFF'
        strokeWidth='1.2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M11.5 16H21.5'
        stroke='#E4ECFF'
        strokeWidth='1.2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
